import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal, SectionLabel, staggerContainer, staggerItem } from "../../lib/motion";
import { AT_A_GLANCE } from "../../data";

export const AtAGlance = () => {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="max-w-2xl">
          <SectionLabel>At a Glance</SectionLabel>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-navy mt-4 leading-tight">
            The essentials, clearly stated
          </h2>
        </Reveal>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5"
        >
          {AT_A_GLANCE.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Circle;
            return (
              <motion.div
                key={item.label}
                variants={staggerItem}
                data-testid={`glance-card-${i}`}
                className="bg-warm-light/60 border border-warm-border rounded-2xl p-6 transition duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-md"
              >
                <div className="w-10 h-10 rounded-xl bg-water/10 flex items-center justify-center">
                  <Icon size={18} strokeWidth={1.5} className="text-water" />
                </div>
                <div className="label-caps text-[10px] text-warm mt-4">{item.label}</div>
                <div className="mt-1.5 text-navy font-semibold leading-snug">{item.value}</div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
